import React from "react";
import { Button, Group } from "@mantine/core";

export default function FilterButtons({
  title,
  items = [],
  onClick,
  activeValue,
  color,
}) {
  return (
    <React.Fragment>
      {title && <h5 style={{ margin: "0 0 7px 0" }}>{title}</h5>}
      <Group spacing="xs">
        {items.map((item, i) => (
          <Button
            key={i}
            onClick={() => onClick(item.value)}
            variant={activeValue === item.value ? "filled" : "light"}
            size="xs"
            radius="xl"
            color={color}
            style={{ marginBottom: "0" }}
          >
            {item.text}
          </Button>
        ))}
      </Group>
    </React.Fragment>
  );
}

FilterButtons.defaultProps = {
  title: "",
  items: [],
};
